import { render } from "./TemporaryDemandStatus.component.vue?vue&type=template&id=51c6bb9c&scoped=true"
import script from "./TemporaryDemandStatus.component.vue?vue&type=script&lang=js"
export * from "./TemporaryDemandStatus.component.vue?vue&type=script&lang=js"

import "./TemporaryDemandStatus.component.vue?vue&type=style&index=0&id=51c6bb9c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51c6bb9c"]])

export default __exports__